import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  GetStartedInput
} from '../../components'
import Styles from './About.css'


@CSSModules(Styles, {allowMultiple:true})
export default class About extends Component {
  render() {
    const title = 'About'
    const url = config.domain + config.routes.about

    const bannerHeadline = 'Fossil Free Funds can help you avoid fossil fuel investments'
    // const bannerSubtitle = ''
    //
    return (
      <div>
        {container.helmet(title, bannerHeadline, url)}

        <ContainerDivs>
          <div styleName='image-banner'>
            <div styleName='image-banner-headline'>
              {bannerHeadline}
            </div>
            { /* <div styleName='image-banner-subtitle'>
              {bannerSubtitle}
            </div> */ }
          </div>
        </ContainerDivs>

        <div styleName='page'>
          <ContainerDivs>
            { /* <div styleName='title'>
              Section title here
            </div> */ }
            <p styleName='lede'>
              <strong>Fossil Free Funds</strong> is a search platform built to help people find out if their money, in the form of individual investments or an employer-offered retirement plan, is being used to extract and consume fossil fuels.
            </p>
            <p styleName='lede'>
              <strong>Owning investments in coal companies, oil/gas producers, and coal-fired utilities isn&rsquo;t just a moral question.</strong> Fossil fuel investments carry real financial risks. When emissions are constrained, fossil fuel companies will have their carbon assets stranded. The implication is that they’re massively overvalued, and markets are realizing that investing in fossil fuels is a risky bet.
            </p>
            <p styleName='lede'>
              <strong>Fossil Free Funds</strong> empowers investors to know exactly what they own, to see if their savings are invested in dirty energy sources, and to find investment options that support a cleaner, greener future.
            </p>
          </ContainerDivs>

          <div styleName='x-401k-container'>
            <div styleName='x-401k-container-inner'>
                <div styleName='x-401k-info-photo'>
                  <div
                    styleName='x-401k-photo'
                    title='401k retirement plans'
                  />
                  <div styleName='x-401k-info'>
                    <div styleName='x-401k-info-title'>
                      Retirement plans
                    </div>
                    <p>For many of us, the majority of our investments are in 401(k)/403(b) plans offered by our employers. These plans invest entirely mostly through mutual funds and exchange-traded funds (ETFs). But those funds can invest in a wide array of securities, and it’s not always easy for investors to investigate what’s inside the funds they own. <strong>Your retirement money may be invested in economically and morally risky fossil fuel companies.</strong></p>
                        <Link
                          to={config.routes.toolkit}
                          title='Fossil free action toolkit'
                        >
                          <div styleName='alink'>
                            Check out our fossil free action toolkit<LinkIcon />
                          </div>
                        </Link>
                  </div>
                </div>
            </div>
          </div>

          <div styleName='x-ays-container'>
            <div styleName='x-ays-container-inner'>
              <div styleName='x-ays-info-photo'>
                <div
                  styleName='x-ays-photo'
                  title='As You Sow'
                />
                <div styleName='x-ays-info'>
                  <div styleName='x-ays-info-title'>
                    As You Sow
                  </div>
                  <p>At As You Sow, we’ve been engaging energy companies on climate change issues for many years. When we decided to make sure our own 401k options were fossil free and socially responsible, we thought it would be simple. In fact, it took weeks of digging just to find out what was inside our plan. And what we found shocked us - oil companies, fossil-fired utilities, and other companies avoided by socially responsible investors. We decided it was time for people who aren’t mutual fund experts to know how much of their retirement money was invested in unsustainable fossil fuel operations.</p>
                  <Link
                    to={config.links.ays}
                    title='As You Sow'
                  >
                    <div styleName='alink'>
                      Visit As You Sow<LinkIcon />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div styleName='x-desktop-container'>
            <div styleName='x-desktop-container-inner'>
              <div styleName='x-desktop-info-photo'>
                <div
                  styleName='x-desktop-photo'
                  title='Your investments should align with your values'
                />
                <div styleName='x-desktop-info'>
                  <div styleName='x-desktop-info-title'>
                    How Fossil Free Funds works
                  </div>
                  <ul>
                    <li>Look up mutual funds and exchange-traded funds (ETFs) using regularly-updated holdings data</li>
                    <li>Analyze your investments for fossil fuel stocks</li>
                    <li>See exposure to fossil finance and insurance, and clean energy leaders</li>
                  </ul>
                  <Link
                    to={config.routes.howitworks}
                    title='How it works | Fossil Free Funds'
                  >
                    <div styleName='alink'>
                      See how it works<LinkIcon />
                    </div>
                  </Link>
                  <br/>
                  <div styleName='x-desktop-info-title'>
                    Use our action toolkit
                  </div>
                  <ul>
                    <li>Learn how to make a change and invest fossil free</li>
                    <li>Ask your financial advisor about fossil free investing</li>
                    <li>Push your employer to provide fossil free options</li>
                  </ul>
                  <Link
                    to={config.routes.toolkit}
                    title='Fossil free action toolkit | Fossil Free Funds'
                  >
                    <div styleName='alink'>
                      View the action toolkit<LinkIcon />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          { /* <div styleName='x-carbon-footprint-wrap'>
            <div styleName='x-carbon-footprint-container'>
              <div styleName='x-carbon-footprint-container-inner'>
                <Link
                  to={config.routes.carbonfootprint}
                  title='Carbon footprint'
                >
                  <div styleName='x-carbon-footprint-info-photo'>
                    <div
                      styleName='x-carbon-footprint-photo'
                      title='Carbon footprint'
                    />
                    <div styleName='x-carbon-footprint-info'>
                      <div styleName='x-carbon-footprint-info-title'>
                        Carbon footprint
                      </div>
                      <p>
                        Fossil fuel companies and those emitting large quantities of CO<sub>2</sub> have come under increasing levels of scrutiny for their large and direct responsibility for climate change. To independently analyze and calculate carbon footprints for the mutual funds, we use the powerful <strong>Carbon Footprint Analysis Tool</strong> of yourSRI.com, which provides information on corporate emissions worldwide.
                      </p>
                      <div styleName='alink'>
                        More<LinkIcon />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div> */ }

          <div styleName='x-cu200-wrap'>
            <div styleName='x-cu200-container'>
              <div styleName='x-cu200-container-inner'>
                <div styleName='x-cu200-info-photo'>
                  <div
                    styleName='x-cu200-photo'
                    title='Carbon Underground 200'
                  />
                  <div styleName='x-cu200-info'>
                    <div styleName='x-cu200-info-title'>
                      Carbon Underground 200&trade;
                    </div>
                    <p>The Carbon Underground 200&trade;, compiled and maintained by FFI Solutions, identifies the top 100 public coal companies globally and the top 100 public oil and gas companies globally, ranked by the potential carbon emissions content of their reported reserves.</p>
                    <Link
                      to={config.routes.carbonunderground200}
                      title='Carbon Underground 200'
                    >
                      <div styleName='alink'>
                        More<LinkIcon />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          { /* <div styleName='banner-pledge-wrap'>
            <div styleName='banner-pledge-container'>
              <div styleName='banner-pledge-container-inner'>
                <div styleName='banner-pledge-quote'>
                  &ldquo;Climate change is real. Now is the time to act.&rdquo;
                </div>
                <div styleName='banner-pledge-cite'>
                  &mdash; Divest Invest Pledge
                </div>
                <div styleName='banner-pledge-info'>
                  Divest Invest Individual invites you to join them in pledging to invest fossil free
                </div>
                <div styleName='banner-pledge-button-wrap'>
                  <Link
                    to={config.links.pledge}
                    title='Divest Invest Pledge'
                    bigbutton={true}
                  >
                    <span styleName='nowrap'>
                      Divest Invest Pledge<LinkIcon />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div> */ }

          <div styleName='x-macroclimate-wrap'>
            <div styleName='x-macroclimate-container'>
              <div styleName='x-macroclimate-container-inner'>
                <div styleName='x-macroclimate-info-photo'>
                  <div
                    styleName='x-macroclimate-photo'
                    title='Macroclimate 50'
                  />
                  <div styleName='x-macroclimate-info'>
                    <div styleName='x-macroclimate-info-title'>
                      Macroclimate<small><sup>&reg;</sup></small> 50
                    </div>
                    <p>Coal is among the largest sources of global warming pollution in the world. Obtaining it destroys mountains, burning it releases hazardous emissions, and disposing of it results in hazardous toxic waste. Coal is scorching the planet and leaving a legacy of devastation in its wake. We partnered with Macroclimate<small><sup>&reg;</sup></small> to screen mutual funds for the Macroclimate<small><sup>&reg;</sup></small> 50 – an exclusion list of the 50 largest public-company owners of coal-fired power plants in Developed Markets plus China and India.</p>
                    <Link
                      to={config.routes.macroclimate50}
                      title='Macroclimate 50'
                    >
                      <div styleName='alink'>
                        More<LinkIcon />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div styleName='x-morningstar-wrap'>
            <div styleName='x-morningstar-container'>
              <div styleName='x-morningstar-container-inner'>
                <Link
                  to={config.routes.morningstar}
                  title='Morningstar'
                >
                  <div styleName='x-morningstar-info-photo'>
                    <div
                      styleName='x-morningstar-photo'
                      title='Morningstar'
                    />
                    <div styleName='x-morningstar-info'>
                      <div styleName='x-morningstar-info-title'>
                        Morningstar investment research
                      </div>
                      <p>
                        Morningstar, Inc. is a leading provider of independent investment research. They provide the financial data on global stocks and U.S. mutual funds, including company industry classifications, that we use to power Fossil Free Funds.
                      </p>
                      <div styleName='alink'>
                        More<LinkIcon />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <div styleName='x-clean200-wrap'>
            <div styleName='x-clean200-container'>
              <div styleName='x-clean200-container-inner'>
                <div styleName='x-clean200-info-photo'>
                  <div
                    styleName='x-clean200-photo'
                    title='Clean200'
                  />
                  <div styleName='x-clean200-info'>
                    <div styleName='x-clean200-info-title'>
                      Clean200
                    </div>
                    <p>Over the past years, a growing movement of investors representing trillions of dollars in assets under management have divested some portion of their fossil fuel investments. But where to invest this capital? The corollary of divesting fossil fuels is re-investing in the clean energy future. As an invitation to a larger discussion of how we can invest in this future, As You Sow and Corporate Knights created the <strong>Carbon Clean 200</strong> — a list of 200 publicly traded companies that are leading the way with solutions for the transition to clean energy.</p>
                    <Link
                      to={config.routes.clean200}
                      title='Clean200'
                    >
                      <div styleName={'alink'}>
                        More<LinkIcon />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <GetStartedInput/>

      </div>
    )
  }
}
